import React from 'react';

import Modal from '@/components/Modals/Modal';
import CircleRadioButton from '@/components/CircleRadioButton';

import { colors } from '@/globalStyles';
import { BodyWrapper, ModalElementWrapper, RadioButton, Label } from './styles';

const RadioButtonsSelectModal = (props) => {
  const {
    header,
    list,
    open,
    setOpen,
    preselect,
    onChange,
    height,
    footer,
    isSmartphone,
  } = props;

  return (
    <Modal
      title={header}
      footer={footer}
      open={open}
      setOpen={setOpen}
      handleClose={() => setOpen(false)}
      backIcon={isSmartphone}
      height={height}
    >
      <BodyWrapper>
        {list.map(({value, label}, indx) =>
          <SelectOption
            key={indx}
            value={value}
            label={label || value}
            selected={preselect === value}
            onClick={onChange}
          />
        )}
      </BodyWrapper>
    </Modal>
  );
};

export default React.memo(RadioButtonsSelectModal);

const SelectOption = ({label, value, selected, onClick}) => (
  <ModalElementWrapper onClick={() => onClick(value)} >
    <RadioButton>
      <CircleRadioButton selected={selected} />
    </RadioButton>
    <Label $color={selected ? colors.primary : null} >
      {label}
    </Label>
  </ModalElementWrapper>
);
